import emptyStateSvg from '@gitlab/svgs/dist/illustrations/empty-state/empty-issues-add-md.svg';
import jiraCloudAppLogo from '@gitlab/svgs/dist/illustrations/third-party-logos/integrations-logos/jira_cloud_app.svg?raw';
import { GlButton, GlEmptyState, GlLink } from '@gitlab/ui';
import { helpPagePath } from '~/helpers/help_page_helper';
import NewResourceDropdown from '~/vue_shared/components/new_resource_dropdown/new_resource_dropdown.vue';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { s__ } from '~/locale';
import { isLoggedIn } from '~/lib/utils/common_utils';
import searchProjectsQuery from '../graphql/search_projects.query.graphql';
export default {
    name: 'EmptyStateWithoutAnyIssues',
    i18n: {
        title: s__('WorkItem|Track bugs, plan features, and organize your efforts with work items'),
        description: s__('WorkItem|Use work items (also known as tickets or stories on other platforms) to collaborate on ideas, solve problems, and plan your project.')
    },
    emptyStateSvg,
    issuesHelpPagePath: helpPagePath('user/project/issues/_index'),
    jiraIntegrationPath: helpPagePath('integration/jira/_index'),
    components: {
        GlButton,
        GlEmptyState,
        GlLink,
        NewResourceDropdown
    },
    directives: {
        SafeHtml
    },
    inject: [
        'canCreateProjects',
        'fullPath',
        'newIssuePath',
        'newProjectPath',
        'showNewIssueLink',
        'signInPath',
        'groupId',
        'isGroup',
        'hasEpicsFeature'
    ],
    props: {
        showNewIssueDropdown: {
            type: Boolean,
            required: false,
            default: false
        },
        hasProjects: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    computed: {
        newIssueDropdownQueryVariables () {
            return {
                fullPath: this.fullPath
            };
        },
        showNewProjectButton () {
            const canCreateGroupLevelWorkItems = this.hasEpicsFeature;
            return this.canCreateProjects && this.isGroup && !this.hasProjects && !canCreateGroupLevelWorkItems;
        }
    },
    methods: {
        extractProjects (data) {
            return data?.group?.projects?.nodes;
        }
    },
    jiraCloudAppLogo,
    searchProjectsQuery
};
